<template>
<div class="subscription_from_balance">
  <div class="header">Оформление подписки:</div>

  <p class="explanation">
    Ниже приведен ваш электронный адрес.
    На этот адрес вы будете получать данные о новых компаниях.
    Чтобы оформить подписку, осталось нажать на кнопку "Оформить".
  </p>

  <img class="arrow" src="../assets/arrow.png" alt="to email" width="18" />

  <span class="email">Ваш Email: <span class="email_value">{{ email }}</span></span>

  <ButtonMakePayment v-if="!created"
    :disabled="pending"
    @click="createSubscription"
    class="button">Оформить
  </ButtonMakePayment>
  <div v-else class="success">
    Подписка № {{ idSubscription }} оформлена! <br>
    Управлять подписками вы можете в
    <a target="_blank" href="/auth/subscription" class="color-blue"><b>личном кабинете</b></a>
  </div>
</div>
</template>

<script>
import ButtonMakePayment from "./ButtonMakePayment";
import api from "./api";
import formurlencoded from "form-urlencoded";

export default {
  name: "SubscriptionFromBalance",
  components: {
    ButtonMakePayment,
  },
  data() {
    return {
      pending: false,
      created: false,
      idSubscription: null,
    };
  },

  props: {
    email: {
      type: String,
      required: true,
    },
  },

  methods: {
    async createSubscription() {
      if (this.pending) {
        return;
      }
      this.pending = true;

      try {
        const subscriptionData = this.getSubscriptionData();
        const subscription = await api.createSubscription(formurlencoded(subscriptionData));
        this.created = true;
        this.idSubscription = subscription.id;
      } catch (e) {
        alert('К сожалению, не удалось оформить подписку. На сервере произошла ошибка.');
      }

      this.pending = false;
    },

    getSubscriptionData() {
      return window.MNewCompaniesSubscription.getFormData(this.email);
    },
  },
}
</script>

<style scoped src="../../../assets/css/color.css"></style>
<style scoped src="../assets/css/style.css"></style>

<style scoped>
.subscription_from_balance {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  align-self: flex-start;
}

.explanation {
  margin-top: 0;
}

.email {
  margin-top: 10px;
  text-align: center;
}

.email_value {
  font-weight: bold;
}

.button {
  margin-top: 15px;
  margin-left: 0;
}

.success {
  margin-top: 15px;
  font-size: 17px;
  text-align: center;
}
</style>
